import React from 'react';
import { Box, Typography } from '@mui/material';
import './AlertsAndNotifications.css';

const AlertsAndNotifications = ({ alerts, onAcknowledge }) => {
  // Function to clean alert message - remove transaction set ID
  const cleanAlertMessage = (message) => {
    if (!message) return '';
    // Remove "transaction set XXX" pattern (case insensitive)
    return message.replace(/transaction\s+set\s+\d+/gi, '').trim();
  };

  return (
    <Box className="alerts-section card">
      <Typography variant="h6" className="alerts-title">
        Alerts and Notifications
      </Typography>
      {alerts.length > 0 ? (
        <Box className="alerts-container scroller">
          {alerts.map((alert) => (
            <Box key={alert.id} className="alerts-item">
              <Box className="alerts-text">
                <Typography className="alerts-primary">
                  {alert.type}: {cleanAlertMessage(alert.message)}
                </Typography>
                <Typography className="alerts-secondary text-secondary">
                  {alert.date}
                </Typography>
              </Box>
              <button
                className="acknowledge-button btn-contained"
                onClick={() => onAcknowledge(alert.id)}
                disabled={alert.status === 'Acknowledged'}
              >
                {alert.status === 'Acknowledged' ? 'Acknowledged' : 'Acknowledge'}
              </button>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography className="no-alerts text-secondary">No alerts available.</Typography>
      )}
    </Box>
  );
};

export default AlertsAndNotifications;